import authStore from "mobx/AuthStore";
import toast from "react-hot-toast";

import { BASE_URL } from "services";
import http from "./httpService";
import { AxiosError } from "axios";

export async function getAllLoans() {
  try {
    const { data } = await http.get(`${BASE_URL}/loans`);
    return data;
  } catch (err) {
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}
export async function getApprovedLoans(params) {
  const query = buildQuery(params);

  try {
    const { data } = await http.get(
      `${BASE_URL}/loans/admin/approved${query ?? ""}`
    );
    return data;
  } catch (err) {
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}

export const buildQuery = (params) => {
  if (!params) return undefined;

  const query = Object.entries(params)
    .filter(([_, value]) => value !== undefined && value !== null)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");

  return query ? `?${query}` : undefined;
};
export async function getRefferedLoans(params) {
  const query = buildQuery(params);

  try {
    const { data } = await http.get(
      `${BASE_URL}/loans/admin/reffered${query ?? ""}`
    );
    return data;
  } catch (err) {
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}
export async function getRefferedMemoLoans(params) {
  const query = buildQuery(params);

  try {
    const { data } = await http.get(
      `${BASE_URL}/loans/admin/reffered/memo${query ?? ""}`
    );
    return data;
  } catch (err) {
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}
export async function getRecentLoans() {
  try {
    const { data } = await http.get(`${BASE_URL}/loans/admin/recent`);
    return data;
  } catch (err) {
    if (err && err.response) {
      // err?.response?.data?.error && toast.error(err.response.data.message)
    } else {
      toast.error("Network Error");
    }
  }
}
export async function getPendingLoans(params) {
  const query = buildQuery(params);
  try {
    const { data } = await http.get(`${BASE_URL}/loans/admin/pending${query}`);
    return data;
  } catch (err) {
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}
export async function getRejectedLoans(params) {
  const query = buildQuery(params);

  try {
    const { data } = await http.get(
      `${BASE_URL}/loans/admin/rejected${query ?? ""}`
    );
    return data;
  } catch (err) {
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}
export async function getAcceptedLoans() {
  try {
    const { data } = await http.get(`${BASE_URL}/loans/admin/accepted`);
    return data;
  } catch (err) {
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}
export async function getDisbursedLoans(params) {
  const query = buildQuery(params);

  try {
    const { data } = await http.get(
      `${BASE_URL}/loans/admin/disbursed${query ?? ""}`
    );
    return data;
  } catch (err) {
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}
export async function getRepaymentHistory(params) {
  const query = buildQuery(params);

  try {
    const { data } = await http.get(
      `${BASE_URL}/loans/admin/repayments${query ?? ""}`
    );
    return data;
  } catch (err) {
    if (err instanceof Error) {
      return {
        status: "failed",
        message: err.message,
      };
    }
    if (err instanceof AxiosError) {
      return {
        status: "failed",
        ...err.response.data,
      };
    }
    return {
      status: "failed",
      message: "An error occurred could not get repayment history",
    };
  }
}
export async function getRepaymentStats() {

  try {
    const { data } = await http.get(
      `${BASE_URL}/loans/admin/repayments/stats`
    );
    return data;
  } catch (err) {
    if (err instanceof Error) {
      return {
        error:true,
        message: err.message,
      };
    }
    if (err instanceof AxiosError) {
      return {
        error:true,
        ...err.response.data,
      };
    }
    return {
      error:true,
      message: "An error occurred could not get repayment history",
    };
  }
}
export async function getLoan(loanId) {
  try {
    const { data } = await http.get(`${BASE_URL}/loans/${loanId}`);
    return data;
  } catch (err) {
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}

export async function updateLoanStatus(payload) {
  authStore.loading();
  try {
    const { data } = await http.put(
      `${BASE_URL}/loans/admin/status/update`,
      payload
    );
    toast.success(data.message);
    authStore.loading();
    return data;
  } catch (err) {
    authStore.loading();
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}
export async function referLoan(payload) {
  authStore.loading();
  try {
    const { data } = await http.post(
      `${BASE_URL}/loans/admin/reffered/`,
      payload
    );
    toast.success(data.message);
    authStore.loading();
    return data;
  } catch (err) {
    authStore.loading();
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}
export async function updateLoanAmount(payload) {
  authStore.loading();
  try {
    const { data } = await http.post(
      `${BASE_URL}/loans/admin/amount/`,
      payload
    );
    // toast.success(data.message)
    authStore.loading();
    return data;
  } catch (err) {
    authStore.loading();
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}
export async function requestEdit(payload) {
  authStore.loading();
  try {
    const { data } = await http.post(
      `${BASE_URL}/loans/admin/edit-request/`,
      payload
    );
    toast.success(data.message);
    authStore.loading();
    return data;
  } catch (err) {
    authStore.loading();
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}
export async function rejectLoan(payload) {
  authStore.loading();
  try {
    const { data } = await http.post(
      `${BASE_URL}/loans/admin/rejected`,
      payload
    );
    toast.success(data.message);
    authStore.loading();
    return data;
  } catch (err) {
    authStore.loading();
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}
export async function loanAnalytics() {
  authStore.loading();
  try {
    const { data } = await http.get(`${BASE_URL}/loans/admin/analytics/board`);
    // toast.success(data.message)
    authStore.loading();
    return data;
  } catch (err) {
    authStore.loading();
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}
export async function getDrafts(params) {
  const query = buildQuery(params);
  try {
    const { data } = await http.get(
      `${BASE_URL}/loans/admin/drafts${query ?? ""}`
    );
    // toast.success(data.message)
    authStore.loading();
    return data;
  } catch (err) {
    authStore.loading();
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}
export async function deleteDraft(id) {
  authStore.loading();
  try {
    const { data } = await http.delete(`${BASE_URL}/loans/admin/drafts/${id}`);
    // toast.success(data.message)
    authStore.loading();
    return data;
  } catch (err) {
    authStore.loading();
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}
export async function deleteMultipleDrafts(ids) {
  authStore.loading();
  try {
    const { data } = await http.post(`${BASE_URL}/loans/admin/drafts/deleted`, {
      ids,
    });
    // toast.success(data.message)
    authStore.loading();
    return data;
  } catch (err) {
    authStore.loading();
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}
export async function sendDraftEmailReminder(payload) {
  authStore.loading();
  try {
    const { data } = await http.post(
      `${BASE_URL}/loans/admin/drafts/email-reminder`,
      payload
    );
    // toast.success(data.message)
    authStore.loading();
    return data;
  } catch (err) {
    authStore.loading();
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}
export async function sendRepaymentEmailReminder(payload) {
  try {
    const { data } = await http.post(
      `${BASE_URL}/loans/admin/repayments/reminder`,
      payload
    );
    return data;
  } catch (err) {
     if (err instanceof Error) {
      return {
        status: "failed",
        message: err.message,
      };
    }
    if (err instanceof AxiosError) {
      return {
        status: "failed",
        ...err.response.data,
      };
    }
    return {
      status: "failed",
      message: "An error occurred could not send repayment reminder",
    };
  }
}
export async function sendMultipleDraftEmailReminder(payload) {
  authStore.loading();
  try {
    const { data } = await http.post(
      `${BASE_URL}/loans/admin/drafts/email-reminders`,
      payload
    );
    // toast.success(data.message)
    authStore.loading();
    return data;
  } catch (err) {
    authStore.loading();
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}
export async function reviewLoanByLPH(id) {
  authStore.loading();
  try {
    const { data } = await http.post(`${BASE_URL}/loans/${id}/lph-reviewed`);
    // toast.success(data.message)
    authStore.loading();
    return data;
  } catch (err) {
    authStore.loading();
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}
export async function reviewLoanByLO(id) {
  authStore.loading();
  try {
    const { data } = await http.post(`${BASE_URL}/loans/${id}/lo-reviewed`);
    // toast.success(data.message)
    authStore.loading();
    return data;
  } catch (err) {
    authStore.loading();
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}
export async function loanChart() {
  authStore.loading();
  try {
    const { data } = await http.get(`${BASE_URL}/loans/admin/chart/board`);
    // toast.success(data.message)
    authStore.loading();
    return data;
  } catch (err) {
    authStore.loading();
    if (err && err.response) {
      err?.response?.data?.error && toast.error(err.response.data.message);
    } else {
      toast.error("Network Error");
    }
  }
}
